import { Typography,Box} from "@mui/material"

const CalendarDayEmpty=(props)=>{
    return(
    <Box sx={{width:"100%", backgroundColor: 'neutral.100'}}>
        <Typography sx={{p:3,color:"white",textAlign:"center"}}>{props.children}</Typography>
    </Box>)
}
export default CalendarDayEmpty